<template>
  <v-main>
    <v-app-bar app flat>
      <v-container class="py-0 fill-height">
        <v-btn
          :href="'https://zerek.edus.kz'"
          v-for="(link, index) in links"
          :key="index"
          text
          class="header-menu-item white--text"
        >
          {{ link }}
        </v-btn>
        <v-btn
          :href="'https://gos.zerek.edus.kz/'"
          text
          class="header-menu-item white--text"
        >
          {{ $t("Государственные организации") }}
        </v-btn>

        <v-responsive class="shrink" style="margin-left: auto">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                depressed
                class="white--text transparent"
              >
                {{ languages[selectedLanguage] }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                link
                v-for="(item, index) in languages"
                :key="index"
                @click.stop="changeLanguage(index)"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-responsive>
      </v-container>
    </v-app-bar>

    <v-container fill-height v-if="!superAdminLogin">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10">
          <v-card class="elevation-10 mt-10 rounded-xl login-card">
            <v-window v-model="step">
              <!-- Госслужащие -->
              <v-window-item :value="2">
                <v-row>
                  <v-col cols="12" md="6" class="pa-8">
                    <h2 class="text-center mb-6 font-weight-bold">{{$t('Для государственных служащих')}}</h2>

                    <v-row v-if="!loginGosRole" dense>
                      <v-col cols="6" v-for="role in loginGosRoles" :key="role.value">
                        <v-card
                          class="role-card hoverable"
                          :class="{ 'selected-role': loginGosRole === role.value }"
                          @click="loginGosRole = role.value"
                        >
                          <v-card-text class="text-center">
                            <v-icon size="40">{{ role.icon }}</v-icon>
                            <div class="mt-2 font-weight-medium">{{ role.label }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-form @submit.prevent="submitLogin" v-else class="mt-8">
                        <v-btn
                        text
                        small
                        color="grey"
                        class="mb-4"
                        @click="loginGosRole = null"
                        >
                            <v-icon left small>mdi-arrow-left</v-icon>
                            {{ $t('Назад') }}
                        </v-btn>
                      <v-file-input
                        color="indigo lighten-1"
                        :label="$t('Выберите файл')"
                        accept=".p12"
                        :rules="[(v) => !!v || $t('Выберите ЭЦП')]"
                        @change="toBase64"
                        outlined
                        :disabled="loading"
                      ></v-file-input>
                      <v-text-field
                        :label="$t('Пароль')"
                        outlined
                        prepend-icon="mdi-lock"
                        v-model="ecpPassword"
                        :type="showPassword ? 'text' : 'parol'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[(v) => !!v || $t('Введите пароль')]"
                        @click:append="showPassword = !showPassword"
                        :disabled="loading"
                      />
                      <v-btn 
                      color="primary" 
                      block 
                      large 
                      type="submit"
                      :loading="loading"
                      >{{ $t('Войти') }}</v-btn>
                    </v-form>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                    class="blue-gradient text-center d-flex flex-column justify-center align-center white--text pa-8 rounded-bl-xl"
                  >
                    <h3 class="mb-4">{{$t('Вы пользователь платформы?')}}</h3>
                    <p>{{$t('Войдите в свой аккаунт для доступа к сервисам')}}</p>
                    <v-btn
                      class="mt-6"
                      outlined
                      dark
                      large
                      @click="step = 1"
                    >
                      {{$t('Войти как пользователь')}}
                      <v-icon right>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-window-item>

              <!-- Пользователи -->
              <v-window-item :value="1">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="blue-gradient text-center d-flex flex-column justify-center align-center white--text pa-8 rounded-br-xl"
                  >
                    <h3 class="mb-4">{{$t('Вы государственный служащий?')}}</h3>
                    <p>{{$t('Войдите в систему для государственных служащих')}}</p>
                    <v-btn
                      class="mt-6"
                      outlined
                      dark
                      large
                      @click="step = 2"
                    >
                      <v-icon left>mdi-arrow-left</v-icon>
                      {{$t('Войти как сотрудник')}}
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="6" class="pa-8">
                    <h2 class="text-center mb-6 font-weight-bold">{{$t('Для пользователей платформы')}}</h2>

                    <v-row v-if="!loginUserRole" dense>
                      <v-col cols="6" v-for="role in loginUserRoles" :key="role.value">
                        <v-card
                          class="role-card hoverable"
                          :class="{ 'selected-role': loginUserRole === role.value }"
                          @click="loginUserRole = role.value"
                        >
                          <v-card-text class="text-center">
                            <v-icon size="40">{{ role.icon }}</v-icon>
                            <div class="mt-2 font-weight-medium">{{ role.label }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-form @submit.prevent="submitLogin" v-else class="mt-8">
                        <v-btn
                        text
                        small
                        color="grey"
                        class="mb-4"
                        @click="loginUserRole = null"
                        >
                            <v-icon left small>mdi-arrow-left</v-icon>
                            {{ $t('Назад') }}
                        </v-btn>
                        <v-file-input
                            color="indigo lighten-1"
                            :label="$t('Выберите файл')"
                            accept=".p12"
                            :rules="[(v) => !!v || $t('Выберите ЭЦП')]"
                            @change="toBase64"
                            outlined
                            :disabled="loading"
                        ></v-file-input>
                        <v-text-field
                            :label="$t('Пароль')"
                            outlined
                            prepend-icon="mdi-lock"
                            v-model="ecpPassword"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[(v) => !!v || $t('Введите пароль')]"
                            @click:append="showPassword = !showPassword"
                            :disabled="loading"
                        />
                      <v-btn 
                      color="primary" 
                      block 
                      large 
                      type="submit"
                      :loading="loading"
                      >{{ $t('Войти') }}</v-btn>
                    </v-form>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>

      <!-- Админ кирген кездеги диалог -->
        <v-dialog v-model="otherAccountsDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="text-h5">
                    {{ $t("Выберите организацию") }}
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="closeAccountDialog()">
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-list three-line>
                        <v-list-item
                            v-for="(account, accountKey) in otherAccounts"
                            :key="accountKey"
                            @click="selectAccount(account)"
                        >
                            <v-list-item-content>
                            <v-list-item-title>{{
                                account.user.branch_name
                            }}</v-list-item-title>
                            <v-list-item-subtitle
                                ><b>{{ account.user.organization_name }}</b>
                                {{ account.user.full_address }}</v-list-item-subtitle
                            >
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>

    <SuperadminLoginPage 
      v-if="superAdminLogin" 
      :language="selectedLanguage"
      @login="handleSuperadminLogin"
    />
  </v-main>
</template>

<script>
import SuperadminLoginPage from './SuperadminLoginPage.vue';
export default {
  components: {
    SuperadminLoginPage
  },
  data() {
    return {
      step: 1,
      showPassword: false,
      loginGosRole: null,
      loginUserRole: null,
      loginGosRoles: [
        { label: this.$t("Управление образования"), value: "head-department", icon: "mdi-office-building" },
        { label: this.$t("Отдел образования"), value: "department", icon: "mdi-school" },
        { label: this.$t("Комиссия"), value: "commission", icon: "mdi-account-tie" },
        { label: this.$t("Оператор (Спорт)"), value: "sport-operator", icon: "mdi-soccer" },
        { label: this.$t("Оператор (Культура)"), value: "culture-operator", icon: "mdi-theater" },
      ],
      loginUserRoles: [
        { label: this.$t("Поставщики"), value: "organization", icon: "mdi-office-building" },
        { label: this.$t("Админ"), value: "admin", icon: "mdi-shield-account" },
        { label: this.$t("Учитель"), value: "staff", icon: "mdi-account-tie" },
      ],
      // { label: this.$t("Родитель"), value: "parent", icon: "mdi-account-child" },
      languages: {
        kk: "Қазақша",
        ru: "Русский",
      },
      links: {
        "/": this.$t("Главная"),
      },
      ecpFileData: null,
      ecpPassword: "",
      otherAccounts: [],
      otherAccountsDialog: false,
      userInfo: null,
      loading: false,
      superAdminLogin: false,
      superAdmin: {
        username: '',
        parol: ''
      },
    };
  },
  created() {
    let langIndex = location.hash.search(/\?lang/);
    if (langIndex != -1) {
      let lang = location.hash.substring(langIndex + 6, langIndex + 8);
      location.hash = location.hash.replace("?lang=" + lang, "");
      this.changeLanguage(lang);
    }
    if(this.$route.params.loginType == 'superadmin'){
        this.superAdminLogin = true;
    }
  },
  computed: {
    selectedLanguage() {
      return this.$store.state.language;
    },
  },
  methods: {
    changeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
      location.reload();
    },
    toBase64(file) {
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
          if (encoded.length % 4 > 0) {
            encoded += "=".repeat(4 - (encoded.length % 4));
          }
          this.ecpFileData = encoded;
        };
      }
    },
    async submitLogin() {
        const role = this.step === 1 ? this.loginUserRole : this.loginGosRole;
        if (!role || !this.ecpPassword || !this.ecpFileData) {
            this.$toast?.error?.(this.$t("Пожалуйста, заполните все поля"));
            return;
        }

        this.loading = true;
        try {
            const url = `/${this.selectedLanguage}/${role}/ecp-auth`;
            const payload = {
                p12: this.ecpFileData,
                parol: this.ecpPassword,
            };

            const response = await this.$http.post(url, payload);
            if (role == "admin") {
                if (response.data.other_accounts.length == 1) {
                    this.login(role, response.data.token, response.data.user);
                } else {
                    this.userInfo = response.data.user;
                    this.otherAccounts = response.data.other_accounts;
                    this.otherAccountsDialog = true;
                }
            } else {
                this.login(role, response.data.token, response.data.user);
            }
            this.loading = false;
        } catch (error) {
            this.$toast?.error?.(this.$t("Ошибка входа"));
            this.loading = false;
        }
    },
    handleSuperadminLogin({ token, user }) {
      this.login('superadmin', token, user);
    },
    login(role, token, user, otherAccounts = []) {
      this.$store
        .dispatch("login", {
          loginType: role,
          token: token,
          user: user,
          otherAccounts: otherAccounts,
        })
        .then(() => {
          this.$router.push({ path: "/" + role });
        });
    },
    closeAccountDialog() {
      this.userInfo = null;
      this.otherAccountsDialog = false;
      this.otherAccounts = [];
    },
    selectAccount(account) {
      this.login("admin", account.token, this.userInfo, this.otherAccounts);
      this.otherAccounts = [];
      this.otherAccountsDialog = false;
    },
  },
};
</script>

<style scoped>
.rounded-bl-xl {
  border-bottom-left-radius: 300px !important;
}
.rounded-br-xl {
  border-bottom-right-radius: 300px !important;
}
.blue-gradient {
  background: linear-gradient(135deg, #1e88e5, #42a5f5);
}
.role-card {
  transition: all 0.2s ease;
  border: 2px solid transparent;
  border-radius: 16px;
}
.role-card:hover {
  border-color: #1976d2;
  transform: scale(1.03);
}
.selected-role {
  border-color: #1976d2 !important;
  background-color: #e3f2fd !important;
}

.v-toolbar {
  background-color: #3097ED !important;
}
.header-menu-item {
  text-transform: initial;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.1px;
}
.header-menu-item.active {
  background-color: rgb(255 255 255 / 20%);
  box-shadow: 0px 0px 10px rgb(14 14 14 / 20%);
  border-radius: 10px;
}
.header-menu-item {
  margin-right: 5px;
}
</style>
